import { useCallback } from "react";

export const useGenerateCSS = () => {
  const kebabCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  };
  const generateCSS = useCallback((elements) => {
    const generatedClasses = new Set();
    let css = "";
    //to remove Scrollbar
    css += `body::-webkit-scrollbar {
  display: none;
  }\n`;
    css += `body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  }\n`;

    const constructBackgroundImageString = (value) => {
      return value ? `url(./${value.split("/").pop()})` : "none";
    };

    elements.forEach((el) => {
      const className = el.classname ? `.${el.classname}` : `.element-${el.id}`;
      // Skip if we've already generated CSS for this class
      if (generatedClasses.has(className)) {
        return;
      }
      // Add the class to our set of generated classes
      generatedClasses.add(className);

      const parentclass = el.parentClassname
        ? `.${el.parentClassname}`
        : `.element-${el.parentId}`;
      let hoverCSS = "";
      let focusCSS = "";
      let activeCSS = "";
      let keyframeCSS = "";
      let elementCSS = "";

      const constructGradientString = () => {
        switch (el.backgroundGradientImage) {
          case "linear-gradient":
            return `linear-gradient(${el.gradientDirection || "to right"}, ${
              el.startColor || "#ff7e5f"
            }, ${el.endColor || "#feb47b"})`;

          case "radial-gradient":
            return `radial-gradient(${el.gradientShape || "circle"} at ${
              el.gradientPosition || "center"
            }, ${el.startColor || "#ff7e5f"}, ${el.endColor || "#feb47b"})`;

          case "repeating-linear-gradient":
            return `repeating-linear-gradient(${el.gradientAngle || "45"}deg, ${
              el.startColor || "#606dbc"
            }, ${el.endColor || "#465298"} ${el.patternLength || "10"}px)`;

          case "repeating-radial-gradient":
            return `repeating-radial-gradient(${
              el.gradientShape || "circle"
            } at ${el.gradientPosition || "center"}, ${
              el.startColor || "#ff7e5f"
            }, ${el.endColor || "#feb47b"} ${el.patternLength || "10"}%)`;

          default:
            return "none";
        }
      };
      const constructlabelGradientString = () => {
        switch (el.labelbackgroundGradientImage) {
          case "linear-gradient":
            return `linear-gradient(${
              el.labelgradientDirection || "to right"
            }, ${el.labelstartColor || "#ff7e5f"}, ${
              el.labelendColor || "#feb47b"
            })`;

          case "radial-gradient":
            return `radial-gradient(${el.labelgradientShape || "circle"} at ${
              el.labelgradientPosition || "center"
            }, ${el.labelstartColor || "#ff7e5f"}, ${
              el.labelendColor || "#feb47b"
            })`;

          case "repeating-linear-gradient":
            return `repeating-linear-gradient(${
              el.labelgradientAngle || "45"
            }deg, ${el.labelstartColor || "#606dbc"}, ${
              el.labelendColor || "#465298"
            } ${el.labelpatternLength || "10"}px)`;

          case "repeating-radial-gradient":
            return `repeating-radial-gradient(${
              el.labelgradientShape || "circle"
            } at ${el.labelgradientPosition || "center"}, ${
              el.labelstartColor || "#ff7e5f"
            }, ${el.labelendColor || "#feb47b"} ${
              el.labelpatternLength || "10"
            }%)`;

          default:
            return "none";
        }
      };
      const constructHoverGradientString = () => {
        switch (el.hoveredbackgroundGradientImage) {
          case "linear-gradient":
            return `linear-gradient(${
              el.hoveredgradientDirection || "to right"
            }, ${el.hoveredstartColor || "#ff7e5f"}, ${
              el.hoveredendColor || "#feb47b"
            })`;

          case "radial-gradient":
            return `radial-gradient(${el.hoveredgradientShape || "circle"} at ${
              el.hoveredgradientPosition || "center"
            }, ${el.hoveredstartColor || "#ff7e5f"}, ${
              el.hoveredendColor || "#feb47b"
            })`;

          case "repeating-linear-gradient":
            return `repeating-linear-gradient(${
              el.hoveredgradientAngle || "45"
            }deg, ${el.hoveredstartColor || "#606dbc"}, ${
              el.hoveredendColor || "#465298"
            } ${el.hoveredpatternLength || "10"}px)`;

          case "repeating-radial-gradient":
            return `repeating-radial-gradient(${
              el.hoveredgradientShape || "circle"
            } at ${el.hoveredgradientPosition || "center"}, ${
              el.hoveredstartColor || "#ff7e5f"
            }, ${el.hoveredendColor || "#feb47b"} ${
              el.hoveredpatternLength || "10"
            }%)`;

          default:
            return "none";
        }
      };
      const constructFocusGradientString = () => {
        switch (el.focusedbackgroundGradientImage) {
          case "linear-gradient":
            return `linear-gradient(${
              el.focusedgradientDirection || "to right"
            }, ${el.focusedstartColor || "#ff7e5f"}, ${
              el.focusedendColor || "#feb47b"
            })`;

          case "radial-gradient":
            return `radial-gradient(${el.focusedgradientShape || "circle"} at ${
              el.focusedgradientPosition || "center"
            }, ${el.focusedstartColor || "#ff7e5f"}, ${
              el.focusedendColor || "#feb47b"
            })`;

          case "repeating-linear-gradient":
            return `repeating-linear-gradient(${
              el.focusedgradientAngle || "45"
            }deg, ${el.focusedstartColor || "#606dbc"}, ${
              el.focusedendColor || "#465298"
            } ${el.focusedpatternLength || "10"}px)`;

          case "repeating-radial-gradient":
            return `repeating-radial-gradient(${
              el.focusedgradientShape || "circle"
            } at ${el.focusedgradientPosition || "center"}, ${
              el.focusedstartColor || "#ff7e5f"
            }, ${el.focusedendColor || "#feb47b"} ${
              el.focusedpatternLength || "10"
            }%)`;

          default:
            return "none";
        }
      };
      const constructAcctiveGradientString = () => {
        switch (el.activatedbackgroundGradientImage) {
          case "linear-gradient":
            return `linear-gradient(${
              el.activatedgradientDirection || "to right"
            }, ${el.activatedstartColor || "#ff7e5f"}, ${
              el.activatedendColor || "#feb47b"
            })`;

          case "radial-gradient":
            return `radial-gradient(${
              el.activatedgradientShape || "circle"
            } at ${el.activatedgradientPosition || "center"}, ${
              el.activatedstartColor || "#ff7e5f"
            }, ${el.activatedendColor || "#feb47b"})`;

          case "repeating-linear-gradient":
            return `repeating-linear-gradient(${
              el.activatedgradientAngle || "45"
            }deg, ${el.activatedstartColor || "#606dbc"}, ${
              el.activatedendColor || "#465298"
            } ${el.activatedpatternLength || "10"}px)`;

          case "repeating-radial-gradient":
            return `repeating-radial-gradient(${
              el.activatedgradientShape || "circle"
            } at ${el.activatedgradientPosition || "center"}, ${
              el.activatedstartColor || "#ff7e5f"
            }, ${el.activatedendColor || "#feb47b"} ${
              el.activatedpatternLength || "10"
            }%)`;

          default:
            return "none";
        }
      };
      if (el.type === "DroppableMap") {
        return;
      }
      if (el.type === "DroppableTable") {
        // Table styles
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "parentClassname",
              "id",
              "parentId",
              "name",
              "type",
              "headers",
              "data",
              "classname",
              "cellPadding",
              "Cellcolor",
              "CellbackgroundColor",
              "backgroundImageCell",
              "backgroundCellRepeat",
              "backgroundCellPosition",
              "backgroundCellSize",
              "backgroundCellAttachment",
              "backgroundCellClip",
              "backgroundHeaderClip",
              "backgroundHeaderAttachment",
              "backgroundHeaderSize",
              "backgroundHeaderPosition",
              "backgroundHeaderRepeat",
              "backgroundImageHeader",
              "HeaderbackgroundColor",
              "Headercolor",
              "headerPadding",
              "borderHeader",
              "borderTopHeader",
              "borderLeftHeader",
              "borderRightHeader",
              "borderBottomHeader",
              "borderRadiusHeader",
              "borderCell",
              "borderTopCell",
              "borderLeftCell",
              "borderRightCell",
              "borderBottomCell",
              "borderRadiusCell",

              "fontSizeHeader",
              "fontFamilyHeader",
              "fontWeightHeader",
              "fontStyleHeader",
              "textAlignHeader",
              "textDecorationHeader",
              "textTransformHeader",

              "fontSizeCell",
              "fontFamilyCell",
              "fontWeightCell",
              "fontStyleCell",
              "textAlignCell",
              "textDecorationCell",
              "textTransformCell",
            ].includes(key)
          ) {
            if (key === "backgroundImage") {
              elementCSS += value
                ? `  background-image: ${constructBackgroundImageString(
                    value
                  )};\n`
                : "";
            } else if (key === "backgroundGradientImage") {
              elementCSS += `  background-image: ${constructGradientString()};\n`;
            } else {
              elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
            }
          }
        });
        if (elementCSS) {
          css += `${className} {\n${elementCSS}\n}\n`;
        }
        elementCSS = "";

        // Header styles
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "id",
              "parentClassname",
              "Id_For_html",
              "parentId",
              "name",
              "type",
              "headers",
              "data",
              "classname",
              "cellPadding",
              "Cellcolor",
              "CellbackgroundColor",
              "backgroundImageCell",
              "backgroundCellRepeat",
              "backgroundCellPosition",
              "backgroundCellSize",
              "backgroundCellAttachment",
              "backgroundCellClip",
              "borderCell",
              "borderTopCell",
              "borderLeftCell",
              "borderRightCell",
              "borderBottomCell",
              "borderRadiusCell",
              "fontSizeCell",
              "fontFamilyCell",
              "fontWeightCell",
              "fontStyleCell",
              "textAlignCell",
              "textDecorationCell",
              "textTransformCell",
            ].includes(key)
          ) {
            let cssProperty;
            switch (key) {
              case "headerPadding":
                cssProperty = "padding";
                break;
              case "Headercolor":
                cssProperty = "color";
                break;
              case "HeaderbackgroundColor":
                cssProperty = "background-color";
                break;
              case "backgroundImageHeader":
                cssProperty = "background-image";
                value = `url(${value})`;
                break;
              case "backgroundHeaderRepeat":
                cssProperty = "background-repeat";
                break;
              case "backgroundHeaderPosition":
                cssProperty = "background-position";
                break;
              case "backgroundHeaderSize":
                cssProperty = "background-size";
                break;
              case "backgroundHeaderAttachment":
                cssProperty = "background-attachment";
                break;
              case "backgroundHeaderClip":
                cssProperty = "background-clip";
                break;
              case "borderHeader":
                cssProperty = "border";
                break;
              case "borderBottomHeader":
                cssProperty = "border-bottom";
                break;
              case "borderTopHeader":
                cssProperty = "border-top";
                break;
              case "borderLeftHeader":
                cssProperty = "border-left";
                break;
              case "borderRightHeader":
                cssProperty = "border-right";
                break;
              case "borderRadiusHeader":
                cssProperty = "border-radius";
                break;
              case "fontSizeHeader":
                cssProperty = "font-size";
                break;
              case "fontFamilyHeader":
                cssProperty = "font-family";
                break;
              case "fontWeightHeader":
                cssProperty = "font-weight";
                break;
              case "fontStyleHeader":
                cssProperty = "font-style";
                break;
              case "textAlignHeader":
                cssProperty = "text-align";
                break;
              case "textDecorationHeader":
                cssProperty = "text-decoration";
                break;
              case "textTransformHeader":
                cssProperty = "text-transform";
                break;
              default:
                return;
            }
            elementCSS += value ? `  ${cssProperty}: ${value};\n` : "";
          }
        });
        if (elementCSS) {
          css += `${className} th {\n${elementCSS}\n}\n`;
        }
        elementCSS = "";

        // Cell styles
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "id",
              "parentClassname",
              "parentId",
              "name",
              "type",
              "headers",
              "data",
              "classname",
              "backgroundHeaderClip",
              "backgroundHeaderAttachment",
              "backgroundHeaderSize",
              "backgroundHeaderPosition",
              "backgroundHeaderRepeat",
              "backgroundImageHeader",
              "HeaderbackgroundColor",
              "Headercolor",
              "headerPadding",
              "borderHeader",
              "borderTopHeader",
              "borderLeftHeader",
              "borderRightHeader",
              "borderBottomHeader",
              "borderRadiusHeader",
              "fontSizeHeader",
              "fontFamilyHeader",
              "fontWeightHeader",
              "fontStyleHeader",
              "textAlignHeader",
              "textDecorationHeader",
              "textTransformHeader",
            ].includes(key)
          ) {
            let cssProperty;
            switch (key) {
              case "cellPadding":
                cssProperty = "padding";
                break;
              case "Cellcolor":
                cssProperty = "color";
                break;
              case "CellbackgroundColor":
                cssProperty = "background-color";
                break;
              case "backgroundImageCell":
                cssProperty = "background-image";
                value = `url(${value})`;
                break;
              case "backgroundCellRepeat":
                cssProperty = "background-repeat";
                break;
              case "backgroundCellPosition":
                cssProperty = "background-position";
                break;
              case "backgroundCellSize":
                cssProperty = "background-size";
                break;
              case "backgroundCellAttachment":
                cssProperty = "background-attachment";
                break;
              case "backgroundCellClip":
                cssProperty = "background-clip";
                break;
              case "borderCell":
                cssProperty = "border";
                break;
              case "borderTopCell":
                cssProperty = "border-top";
                break;
              case "borderBottomCell":
                cssProperty = "border-bottom";
                break;
              case "borderLeftCell":
                cssProperty = "border-left";
                break;
              case "borderRightCell":
                cssProperty = "border-right";
                break;
              case "borderRadiusCell":
                cssProperty = "border-radius";
                break;
              case "fontSizeCell":
                cssProperty = "font-size";
                break;
              case "fontFamilyCell":
                cssProperty = "font-family";
                break;
              case "fontWeightCell":
                cssProperty = "font-weight";
                break;
              case "fontStyleCell":
                cssProperty = "font-style";
                break;
              case "textAlignCell":
                cssProperty = "text-align";
                break;
              case "textDecorationCell":
                cssProperty = "text-decoration";
                break;
              case "textTransformCell":
                cssProperty = "text-transform";
                break;
              default:
                return;
            }
            elementCSS += value ? `  ${cssProperty}: ${value};\n` : "";
          }
        });
        if (elementCSS) {
          css += `${className} td {\n${elementCSS}\n}\n`;
        }
        elementCSS = "";
      } else if (
        el.type === "DroppableVideo" ||
        el.type === "DroppableMap" ||
        el.type === "DroppableImage" ||
        el.type === "DroppableIframe"
      ) {
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "id",
              "parentClassname",
              "parentId",
              "name",
              "type",
              "src",
              "alt",
              "title",
              "url",
              "posterUrl",
              "poster",
              "lat",
              "lng",
              "zoom",
              "searchQuery",
              "redirectTo",
              "classname",
              "pseudoClass",
            ].includes(key)
          ) {
            if (el.pseudoClass === "hover" && key.startsWith("hovered")) {
              if (key === "hoveredbackgroundImage") {
                hoverCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "hovered"
                )};\n`;
              } else if (key === "hoveredbackgroundGradientImage") {
                hoverCSS += `  background-image: ${constructGradientString(
                  "hovered"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("hovered", ""));
                hoverCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "focus" &&
              key.startsWith("focused")
            ) {
              if (key === "focusedbackgroundImage") {
                focusCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "focused"
                )};\n`;
              } else if (key === "focusedbackgroundGradientImage") {
                focusCSS += `  background-image: ${constructGradientString(
                  "focused"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("focused", ""));
                focusCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "active" &&
              key.startsWith("activated")
            ) {
              if (key === "activatedbackgroundImage") {
                activeCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "activated"
                )};\n`;
              } else if (key === "activatedbackgroundGradientImage") {
                activeCSS += `  background-image: ${constructGradientString(
                  "activated"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("activated", ""));
                activeCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else {
              if (key === "backgroundImage") {
                elementCSS += value
                  ? `  background-image: ${constructBackgroundImageString(
                      value
                    )};\n`
                  : "";
              } else if (key === "backgroundGradientImage") {
                elementCSS += `  background-image: ${constructGradientString()};\n`;
              } else if (key === "keyframeCSS") {
                keyframeCSS += value ? ` ${value}\n` : "";
              } else if (
                key.startsWith("skew") ||
                key.startsWith("scale") ||
                key.startsWith("translate") ||
                key === "rotate" ||
                key.startsWith("KEY")
              ) {
                return;
              } else {
                elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
              }
            }
          }
        });

        if (elementCSS) {
          css += `${className} {\n${elementCSS}\n}\n`;
        }
        if (hoverCSS) {
          css += `${className}:hover {\n${hoverCSS}\n}\n`;
        }
        if (focusCSS) {
          css += `${className}:focus {\n${focusCSS}\n}\n`;
        }
        if (activeCSS) {
          css += `${className}:active {\n${activeCSS}\n}\n`;
        }
        if (keyframeCSS) {
          css += `\n${keyframeCSS}\n\n`;
        }
      }

      // Audio Component Css Generation Panding
      else if (el.type === "DroppableAudio") {
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "id",
              "parentId",
              "name",
              "type",
              "src",
              "alt",
              "title",
              "url",
              "posterUrl",
              "poster",
              "lat",
              "lng",
              "zoom",
              "searchQuery",
              "redirectTo",
              "classname",
              "pseudoClass",
              "parentClassname",
            ].includes(key)
          ) {
            if (el.pseudoClass === "hover" && key.startsWith("hovered")) {
              if (key === "hoveredbackgroundImage") {
                hoverCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "hovered"
                )};\n`;
              } else if (key === "hoveredbackgroundGradientImage") {
                hoverCSS += `  background-image: ${constructGradientString(
                  "hovered"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("hovered", ""));
                hoverCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "focus" &&
              key.startsWith("focused")
            ) {
              if (key === "focusedbackgroundImage") {
                focusCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "focused"
                )};\n`;
              } else if (key === "focusedbackgroundGradientImage") {
                focusCSS += `  background-image: ${constructGradientString(
                  "focused"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("focused", ""));
                focusCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "active" &&
              key.startsWith("activated")
            ) {
              if (key === "activatedbackgroundImage") {
                activeCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "activated"
                )};\n`;
              } else if (key === "activatedbackgroundGradientImage") {
                activeCSS += `  background-image: ${constructGradientString(
                  "activated"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("activated", ""));
                activeCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else {
              elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
            }
          }
        });

        if (elementCSS) {
          css += `${parentclass} audio {\n${elementCSS}\n}\n`;
        }
        if (hoverCSS) {
          css += `${parentclass} audio:hover {\n${hoverCSS}\n}\n`;
        }
        if (focusCSS) {
          css += `${parentclass} audio:focus {\n${focusCSS}\n}\n`;
        }
        if (activeCSS) {
          css += `${parentclass} audio:active {\n${activeCSS}\n}\n`;
        }
      } else if (
        el.type === "DroppableList" ||
        el.type === "DroppableLink" ||
        el.type === "DroppableIcon" ||
        el.type === "DroppableButton"
      ) {
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "id",
              "parentClassname",
              "parentId",
              "name",
              "type",
              "items",
              "Type",
              "iconName",
              "text",
              "href",
              "target",
              "rel",
              "label",
              "redirectTo",
              "classname",
              "pseudoClass",
              "gradientDirection",
              "gradientShape",
              "gradientPosition",
              "startColor",
              "endColor",
              "gradientAngle",
              "patternLength",
              "iconName",
            ].includes(key)
          ) {
            if (el.pseudoClass === "hover" && key.startsWith("hovered")) {
              if (key === "hoveredbackgroundImage") {
                hoverCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "hovered"
                )};\n`;
              } else if (key === "hoveredbackgroundGradientImage") {
                hoverCSS += `  background-image: ${constructGradientString(
                  "hovered"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("hovered", ""));
                hoverCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "focus" &&
              key.startsWith("focused")
            ) {
              if (key === "focusedbackgroundImage") {
                focusCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "focused"
                )};\n`;
              } else if (key === "focusedbackgroundGradientImage") {
                focusCSS += `  background-image: ${constructGradientString(
                  "focused"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("focused", ""));
                focusCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "active" &&
              key.startsWith("activated")
            ) {
              if (key === "activatedbackgroundImage") {
                activeCSS += `  background-image: ${constructBackgroundImageString(
                  value,
                  "activated"
                )};\n`;
              } else if (key === "activatedbackgroundGradientImage") {
                activeCSS += `  background-image: ${constructGradientString(
                  "activated"
                )};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("activated", ""));
                activeCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else {
              if (
                key === "backgroundImage" ||
                key === "backgroundGradientImage" ||
                key === "listStyleImage"
              ) {
                // Check if both backgroundImage and backgroundGradientImage are present
                if (key === "backgroundImage" && value) {
                  if (!elementCSS.includes("background-image")) {
                    elementCSS += `  background-image: url(${value});\n`;
                  }
                } else if (key === "backgroundGradientImage") {
                  if (!elementCSS.includes("background-image")) {
                    elementCSS += `  background-image: ${constructGradientString()};\n`;
                  }
                } else if (key === "listStyleImage") {
                  if (!elementCSS.includes("list-style-image")) {
                    elementCSS += `  list-style-image: url(${value});\n`;
                  }
                }
              } else if (key === "IconSize") {
                elementCSS += value ? `  font-size:${value};\n` : "";
              } else if (key === "keyframeCSS") {
                keyframeCSS += value ? ` ${value}\n` : "";
              } else if (
                key.startsWith("skew") ||
                key.startsWith("scale") ||
                key.startsWith("translate") ||
                key === "rotate" ||
                key.startsWith("KEY")
              ) {
                return;
              } else {
                elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
              }
            }
          }
        });

        if (elementCSS) {
          css += `${className} {\n${elementCSS}\n}\n`;
        }
        if (hoverCSS) {
          css += `${className}:hover {\n${hoverCSS}\n}\n`;
        }
        if (focusCSS) {
          css += `${className}:focus {\n${focusCSS}\n}\n`;
        }
        if (activeCSS) {
          css += `${className}:active {\n${activeCSS}\n}\n`;
        }
        if (keyframeCSS) {
          css += `\n${keyframeCSS}\n\n`;
        }
      } else if (
        el.type === "DroppableHeading" ||
        el.type === "DroppableParagraph"
      ) {
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "Id_For_html",
              "id",
              "parentClassname",
              "parentId",
              "name",
              "type",
              "text",
              "level",
              "classname",
              "pseudoClass",
              "gradientDirection",
              "gradientShape",
              "gradientPosition",
              "startColor",
              "endColor",
              "gradientAngle",
              "patternLength",
            ].includes(key)
          ) {
            if (el.pseudoClass === "hover" && key.startsWith("hovered")) {
              if (key === "hoveredbackgroundImage") {
                hoverCSS += value
                  ? `  ${kebabCase(
                      key.replace("hovered", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "hoveredbackgroundGradientImage") {
                hoverCSS += `  background-image: ${constructHoverGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("hovered", ""));
                hoverCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "focus" &&
              key.startsWith("focused")
            ) {
              if (key === "focusedbackgroundImage") {
                focusCSS += value
                  ? `  ${kebabCase(
                      key.replace("focused", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "focusedbackgroundGradientImage") {
                focusCSS += `  background-image: ${constructFocusGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("focused", ""));
                focusCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "active" &&
              key.startsWith("activated")
            ) {
              if (key === "activatedbackgroundImage") {
                activeCSS += value
                  ? `  ${kebabCase(
                      key.replace("activated", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "activatedbackgroundGradientImage") {
                activeCSS += `  background-image: ${constructAcctiveGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("activated", ""));
                activeCSS += `  ${cssProperty}: ${value};\n`;
              }
            }
            if (
              key === "backgroundImage" ||
              key === "backgroundGradientImage"
            ) {
              // Check if both backgroundImage and backgroundGradientImage are present
              if (key === "backgroundImage" && value) {
                if (!elementCSS.includes("background-image")) {
                  elementCSS += `  background-image: url(${value});\n`;
                }
              } else if (key === "backgroundGradientImage") {
                if (!elementCSS.includes("background-image")) {
                  elementCSS += `  background-image: ${constructGradientString()};\n`;
                }
              }
            } else if (key === "keyframeCSS") {
              keyframeCSS += ` ${value}\n`;
            } else if (
              key.startsWith("skew") ||
              key.startsWith("scale") ||
              key.startsWith("translate") ||
              key === "rotate" ||
              key.startsWith("KEY")
            ) {
              return;
            } else {
              elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
            }
          }
        });
        if (elementCSS) {
          css += `${className}{\n${elementCSS}\n}\n`;
        }
        if (keyframeCSS) {
          css += `\n${keyframeCSS}\n\n`;
        }
        if (hoverCSS) {
          css += `${className}:hover{\n${hoverCSS}\n}\n`;
        }
        if (focusCSS) {
          css += `${className}:focus{\n${focusCSS}\n}\n`;
        }
        if (activeCSS) {
          css += `${className}:active{\n${activeCSS}\n}\n`;
        }
      } else if (
        el.type === "DroppableTextInput" ||
        el.type === "DroppablePasswordInput" ||
        el.type === "DroppableEmailInput" ||
        el.type === "DroppableNumberInput" ||
        el.type === "DroppableDateInput" ||
        el.type === "DroppableColorInput" ||
        el.type === "DroppableFileInput" ||
        el.type === "DroppableRangeInput" ||
        el.type === "DroppableOutput"
      ) {
        hoverCSS = "";
        focusCSS = "";
        activeCSS = "";

        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            key.startsWith("label") &&
            ![
              "id",
              "parentId",
              "name",
              "type",
              "placeholder",
              "parentClassname",
              "value",
            ].includes(key)
          ) {
            if (key === "labelbackgroundImage") {
              elementCSS += value
                ? `  background-image: url('${value}');\n`
                : "";
            } else if (key === "labelbackgroundGradientImage") {
              elementCSS += `  background-image: ${constructlabelGradientString()};\n`;
            } else if (
              !key.startsWith("focused") &&
              !key.startsWith("hovered") &&
              !key.startsWith("activated") &&
              ![
                "id",
                "parentClassname",
                "parentId",
                "name",
                "type",
                "placeholder",
                "label",
                "value",
                "classname",
                "Id_For_html",
                "pseudoClass",
                "gradientDirection",
                "gradientShape",
                "gradientPosition",
                "startColor",
                "endColor",
                "gradientAngle",
                "patternLength",
                "backgroundImage",
                "backgroundGradientImage",
                "for",
              ].includes(key)
            ) {
              const cssProperty = kebabCase(key.replace("label", ""));
              elementCSS += value ? `  ${cssProperty}: ${value};\n` : "";
            }
          }
        });

        if (elementCSS) {
          css += `${className}-label {\n${elementCSS}}\n`;
        }
        elementCSS = "";

        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            !key.startsWith("label") &&
            ![
              "id",
              "parentId",
              "name",
              "parentClassname",
              "type",
              "placeholder",
              "label",
              "value",
              "classname",
              "Id_For_html",
              "pseudoClass",
              "gradientDirection",
              "gradientShape",
              "gradientPosition",
              "startColor",
              "endColor",
              "gradientAngle",
              "patternLength",
              "labelbackgroundImage",
              "labelbackgroundGradientImage",
              "for",
            ].includes(key)
          ) {
            if (el.pseudoClass === "hover" && key.startsWith("hovered")) {
              if (key === "hoveredbackgroundImage") {
                hoverCSS += value
                  ? `  ${kebabCase(
                      key.replace("hovered", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "hoveredbackgroundGradientImage") {
                hoverCSS += `  background-image: ${constructHoverGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("hovered", ""));
                hoverCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "focus" &&
              key.startsWith("focused")
            ) {
              if (key === "focusedbackgroundImage") {
                focusCSS += value
                  ? `  ${kebabCase(
                      key.replace("focused", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "focusedbackgroundGradientImage") {
                focusCSS += `  background-image: ${constructFocusGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("focused", ""));
                focusCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "active" &&
              key.startsWith("activated")
            ) {
              if (key === "activatedbackgroundImage") {
                activeCSS += value
                  ? `  ${kebabCase(
                      key.replace("activated", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "activatedbackgroundGradientImage") {
                activeCSS += `  background-image: ${constructAcctiveGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("activated", ""));
                activeCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else {
              if (
                key === "backgroundImage" ||
                key === "backgroundGradientImage"
              ) {
                // Check if both backgroundImage and backgroundGradientImage are present
                if (key === "backgroundImage" && value) {
                  if (!elementCSS.includes("background-image")) {
                    elementCSS += `  background-image: url(${value});\n`;
                  }
                } else if (key === "backgroundGradientImage") {
                  if (!elementCSS.includes("background-image")) {
                    elementCSS += `  background-image: ${constructGradientString()};\n`;
                  }
                }
              } else {
                elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
              }
            }
          }
        });

        if (elementCSS) {
          css += `${className}-input {\n${elementCSS}\n}\n`;
        }
        if (hoverCSS) {
          css += `${className}-input:hover {\n${hoverCSS}\n}\n`;
        }
        if (focusCSS) {
          css += `${className}-input:focus {\n${focusCSS}\n}\n`;
        }
        if (activeCSS) {
          css += `${className}-input:active {\n${activeCSS}\n}\n`;
        }
        elementCSS = "";
      } else {
        Object.entries(el).forEach(([key, value]) => {
          if (
            typeof value === "string" &&
            ![
              "id",
              "parentId",
              "parentClassname",
              "name",
              "type",
              "headers",
              "data",
              "classname",
              "Id_For_html",
              "pseudoClass",
              "gradientDirection",
              "gradientShape",
              "gradientPosition",
              "startColor",
              "endColor",
              "gradientAngle",
              "patternLength",
              "iframeCode",
              "titleMap",
            ].includes(key)
          ) {
            if (el.pseudoClass === "hover" && key.startsWith("hovered")) {
              if (key === "hoveredbackgroundImage") {
                hoverCSS += value
                  ? `  ${kebabCase(
                      key.replace("hovered", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "hoveredbackgroundGradientImage") {
                hoverCSS += `  background-image: ${constructHoverGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("hovered", ""));
                hoverCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "focus" &&
              key.startsWith("focused")
            ) {
              if (key === "focusedbackgroundImage") {
                focusCSS += value
                  ? `  ${kebabCase(
                      key.replace("focused", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "focusedbackgroundGradientImage") {
                focusCSS += `  background-image: ${constructFocusGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("focused", ""));
                focusCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else if (
              el.pseudoClass === "active" &&
              key.startsWith("activated")
            ) {
              if (key === "activatedbackgroundImage") {
                activeCSS += value
                  ? `  ${kebabCase(
                      key.replace("activated", "")
                    )}: url('${value}');\n`
                  : "";
              } else if (key === "activatedbackgroundGradientImage") {
                activeCSS += `  background-image: ${constructAcctiveGradientString()};\n`;
              } else {
                const cssProperty = kebabCase(key.replace("activated", ""));
                activeCSS += `  ${cssProperty}: ${value};\n`;
              }
            } else {
              if (
                key === "backgroundImage" ||
                key === "backgroundGradientImage"
              ) {
                // Check if both backgroundImage and backgroundGradientImage are present
                if (key === "backgroundImage" && value) {
                  if (!elementCSS.includes("background-image")) {
                    elementCSS += `  background-image: url(${value});\n`;
                  }
                } else if (key === "backgroundGradientImage") {
                  if (!elementCSS.includes("background-image")) {
                    elementCSS += `  background-image: ${constructGradientString()};\n`;
                  }
                }
              } else if (key === "keyframeCSS") {
                keyframeCSS += value ? ` ${value}\n` : "";
              } else if (
                key.startsWith("skew") ||
                key.startsWith("scale") ||
                key.startsWith("translate") ||
                key === "rotate" ||
                key.startsWith("KEY")
              ) {
                return;
              } else {
                elementCSS += value ? `  ${kebabCase(key)}: ${value};\n` : "";
              }
            }
          }
        });
        if (elementCSS) {
          css += `${className} {\n${elementCSS}\n}\n`;
        }
        if (hoverCSS) {
          css += `${className}:hover{\n${hoverCSS}\n}\n`;
        }
        if (focusCSS) {
          css += `${className}:focus{\n${focusCSS}\n}\n`;
        }
        if (activeCSS) {
          css += `${className}:active{\n${activeCSS}\n}\n`;
        }
        if (keyframeCSS) {
          css += `\n${keyframeCSS}\n\n`;
        }
      }
    });

    return css.trim();
  }, []);
  return { generateCSS };
};
